export const COUNTY_EDIT_CONTRACTOR = {
  id: 'countyEditContractor',
  label: 'Edytuj wykonawcę',
  iconClass: 'fa fa-pencil'
};
